module.exports = __webpack_public_path__ + "img/speed_zone.b8e077fc.svg";